import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_new_upsell_design~1
			upsell: {
				experiment: {
					'upsell-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_new_upsell_design__upsell_f'
						),
				},
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_new_upsell_design~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_new_upsell_design__upsell_tcw_f'
						),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_new_upsell_design~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_new_upsell_design__upsell_tcw_f'
						),
				},
			},
		},
	},
]

export default config
